export interface AppLayoutPresentation {
  showSidebar: boolean
  showSidebarTour: boolean
}

export function getAppLayoutPresentation(pathname: string): AppLayoutPresentation {
  void pathname

  return {
    showSidebar: true,
    showSidebarTour: true,
  }
}
